import { render, staticRenderFns } from "./Denounces.vue?vue&type=template&id=7d78cc49&scoped=true&"
import script from "./Denounces.vue?vue&type=script&lang=js&"
export * from "./Denounces.vue?vue&type=script&lang=js&"
import style0 from "./Denounces.vue?vue&type=style&index=0&id=7d78cc49&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d78cc49",
  null
  
)

export default component.exports